import { useMemo, useState } from 'react';

// Surfaces that take over part of the page (the AI block editor sidebar) hide
// the plugin overlays (floating frames and their launcher circles) while they
// are open, the way an open modal does (hiddenByModal). Suppression is
// counted, so two surfaces open at once keep the overlays hidden until both
// are gone.

// Returns a function that suppresses once and hands back its own release.
// A release is idempotent: calling it twice (StrictMode, a double cleanup)
// never releases someone else's suppression.
export const createOverlaySuppressor =
  (adjust: (delta: 1 | -1) => void) => () => {
    let released = false;
    adjust(1);
    return () => {
      if (released) return;
      released = true;
      adjust(-1);
    };
  };

export const useOverlaySuppression = () => {
  const [count, setCount] = useState(0);
  // Stable for the provider's lifetime, so consumers' effects run once
  const suppressOverlays = useMemo(
    () =>
      createOverlaySuppressor((delta) =>
        setCount((prev) => Math.max(0, prev + delta))
      ),
    []
  );
  return { hiddenByEditor: count > 0, suppressOverlays };
};
